import { render, staticRenderFns } from "./WarrantyType.vue?vue&type=template&id=3b946c63&"
import script from "./WarrantyType.vue?vue&type=script&lang=js&"
export * from "./WarrantyType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports